import { fork } from 'redux-saga/effects';
import api from './api/saga';


export default function* services() {
  yield fork(api);
}



// WEBPACK FOOTER //
// ../redux/store/services/saga.js